
export default {
  props: {
    status: {
      type: String,
      default: null
    },
    truncate: {
      type: Boolean,
      default: false
    },
    minimal: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    availability: {
      color: 'grey-darkest'
    },
    dot: {
      width: '2xs',
      height: '2xs',
      borderRadius: 'full',
      backgroundColor() {
        const colors = {
          available: 'success',
          backorder: 'warning',
          unavailable: 'danger'
        }

        return colors[this.status] || 'grey'
      }
    },
    label: {
      $truncate: 'textTruncate',
      overflow: 'hidden',
      marginLeft: 'xs'
    }
  },
  computed: {
    text() {
      return this.$t(`product.availability.${this.status}`)
    },
    label() {
      return this.minimal ? this.$t('product.availability.title') : this.text
    }
  }
}
